import { render } from "./RequestList.vue?vue&type=template&id=15dd10ab&scoped=true"
import script from "./RequestList.js?vue&type=script&lang=js&external"
export * from "./RequestList.js?vue&type=script&lang=js&external"

import "./RequestList.scss?vue&type=style&index=0&id=15dd10ab&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15dd10ab"]])

export default __exports__